<template>
  <div class="modal-container">
    <div class="modal-content">
      <slot />
    </div>
    <div class="modal-footer">
      <img @click.stop="closeModal" class="modal-footer-close-btn" :src="imageUrl('close-modal.png')" />
    </div>
  </div>
</template>

<script>
import Mixins from "../../mixins/mixins";
import DeactivateScroll from "../../mixins/deactivate-scroll";

export default {
  components: {},
  props: [],
  mixins: [Mixins, DeactivateScroll],
  methods: {
    closeModal() {
      this.$parent.$emit("closeModal");
      document.getElementById('main-wrapper').classList.add('allow-scrolling');
    },
    created() {
    }
  }
};
</script>

<style lang="scss" scoped>
  .modal-container {
    height: 100vh;
    width: 100vw;
    z-index: 99999999999999;
    position: fixed;
    background: linear-gradient(to bottom, white 0%, white 25%, rgba(255, 255, 255, 0.9) 62%, rgba(255, 255, 255, 0.8) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#ccffffff',GradientType=0 );
    top: 0;
    &.solid{
      background-color: white;
    }
    .modal-content {
      margin: 15px auto;
      height: 100%;
    }
    .modal-footer {
      background-color: white;
      top: calc(100% - 80px);
      width: 100%;
      position: fixed;
      &-close-btn {
        opacity: 0.5;
        width: 29px;
        margin: 30px auto;
      }
    }
  }
</style>